import { render, staticRenderFns } from "./Form6ProcessHeader.vue?vue&type=template&id=6b0e15ce&scoped=true"
import script from "./Form6ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form6ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form6ProcessHeader.vue?vue&type=style&index=0&id=6b0e15ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e15ce",
  null
  
)

export default component.exports